import { queryOptions } from '@tanstack/react-query'

import { listCompetitionScopes } from './api'

export const competitionScopeQueryKeys = {
  all: ['competition-scopes'] as const,
}

export function competitionScopesQueryOptions() {
  return queryOptions({
    queryKey: competitionScopeQueryKeys.all,
    queryFn: listCompetitionScopes,
    staleTime: 5 * 60 * 1000,
  })
}
